import { onboardingTour } from "./onboardingTour";
import { dashboardTour } from "./dashboardTour";
import { manualQueryTour } from "./manualQueryTour";
import { manualQueryDetailTour } from "./manualQueryDetailTour";
import { conversationTour } from "./conversationTour";
import { emailQueriesTour } from "./emailQueriesTour";
import { quoteDetailTour } from "./quoteDetailTour";
import { rateRequestTour } from "./rateRequestTour";

/**
 * Registry of all tours keyed by tour ID.
 * Add new tours here; the rest of the system picks them up automatically.
 */
export const TOURS = {
  [onboardingTour.id]: onboardingTour,
  [dashboardTour.id]: dashboardTour,
  [manualQueryTour.id]: manualQueryTour,
  [manualQueryDetailTour.id]: manualQueryDetailTour,
  [conversationTour.id]: conversationTour,
  [emailQueriesTour.id]: emailQueriesTour,
  [quoteDetailTour.id]: quoteDetailTour,
  [rateRequestTour.id]: rateRequestTour,
};

export {
  onboardingTour,
  dashboardTour,
  manualQueryTour,
  manualQueryDetailTour,
  conversationTour,
  emailQueriesTour,
  quoteDetailTour,
  rateRequestTour,
};
